import { COLORS } from "@app/constants";
import React, { useContext } from "react";
import { ThemeContext } from "@/theme/ThemeProvider";
import IdentifyBody from "./IdentifyBody";
import IdentifyHeader from "./IdentifyHeader";
import { IdentifyVerificationSection } from "../styles";

const IdentifyVerification = ({ title, level, last }: any) => {
  const { isDarkMode } = useContext(ThemeContext);
  
  return (
    <IdentifyVerificationSection
    >
      <IdentifyHeader level={level} title={title} />
      <IdentifyBody level={level} last={last} />
    </IdentifyVerificationSection>
  );
};

export default IdentifyVerification;
